import { camelizeKeys } from 'humps'

const defaultState = {
  isCartOpen: false,
  alert: null,
  isProductListExpanded: false,
  newPlayer: {
    id: null,
    lastName: '',
    phoneNumber: '',
    email: ''
  }
}

const loadInitialState = (params) =>
  App.payment
  ? {
      ...defaultState,
      ...params,
      creditCardList: {items: camelizeKeys(window.App.cards)}
    }
  : defaultState

const handlePlayerChange = (state, params) => {
  const newState = {
    ...state,
    newPlayer: {...state.newPlayer, ...params}
  }
  return newState
}

const updateCardsList = (state, cards) => {
  return {...state, creditCardList: {items: camelizeKeys(cards)} }
}

const reservationPayment = (state = defaultState, {type, payload}) => {
  switch (type) {
    case 'PAYMENT_MODAL.INIT':
      return loadInitialState(payload)
    case 'PAYMENT_MODAL.CLEAR_CARDS':
      window.App.cards = []
      return {...state, creditCardList: {items: []}}
    case 'PAYMENT_MODAL_TOGGLE_CART':
      return {...state, isCartOpen: !state.isCartOpen}
    case 'PAYMENT_MODAL_EXPAND_PRODUCTS':
      return {...state, isProductListExpanded: true}
    case 'PAYMENT_MODAL_COLLAPSE_PRODUCTS':
      return {...state, isProductListExpanded: false}
    case 'SHOP_CART_ADD_ITEM':
      return {...state, isCartOpen: true}
    case 'PAYMENT_MODAL_PLAYER_CHANGED':
      return handlePlayerChange(state, payload)
    case 'PAYMENT_MODAL.UPDATE_CARDS':
      return updateCardsList(state, payload)
    case 'PAYMENT_MODAL.CLEAR_DATA':
      return defaultState
    case 'PAYMENT_MODAL.START_LOADING':
      return {...state, isLoading: true}
    case 'PAYMENT_SUCCESS':
      if (_.isEmpty(state)) return state
      return {...defaultState, isLoading: false}
    case 'PAYMENT_ERROR':
      if (_.isEmpty(state)) return state
      return {...state, isLoading: false}
    default:
      return state
  }
}

export default reservationPayment
